import React from "react";
import { ModalLoaderWrapper } from "./CommonStyles";
import Spinner from "./Spinner";
import useEmpresa from "../../hooks/useEmpresa";

const ModalLoader = () => {
  const empresa = useEmpresa();
  return (
    <ModalLoaderWrapper>
      <Spinner size={20} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
    </ModalLoaderWrapper>
  );
};

export default ModalLoader;